// extracted by mini-css-extract-plugin
module.exports = {"topBox":"topBox--Rqtr0","content":"content--cixa6","inner":"inner--F5jNl","termsAndConditions":"termsAndConditions--Zsn2H"};